import { Injectable, signal, computed } from '@angular/core';

/**
 * Service to track the current simulation context (profile name).
 * Used by UI components to determine if we're in a fast simulation mode.
 */
@Injectable({
  providedIn: 'root'
})
export class SimulationContextService {
  private readonly activeSimulationProfile = signal<string | null>(null);

  /**
   * Computed signal: currently active simulation profile name (or null if not simulating)
   */
  readonly activeProfile = computed(() => this.activeSimulationProfile());

  /**
   * Computed signal: check if currently running a fast simulation (not TimeAwareReplay)
   */
  readonly isRunningFastSimulation = computed(() => {
    const profile = this.activeSimulationProfile();
    if (!profile) {
      return false;
    }

    // Fast profiles are all except TimeAwareReplay
    const fastProfiles = ['QuickValidation', 'FastValidation', 'Replay', 'StressTest', 'ParallelSyntheticPacing'];
    return fastProfiles.includes(profile);
  });

  /**
   * Set the active simulation profile (called when a simulation starts)
   */
  setActiveProfile(profileName: string): void {
    this.activeSimulationProfile.set(profileName);
  }

  /**
   * Clear the active simulation (called when a simulation stops/completes)
   */
  clearActiveProfile(): void {
    this.activeSimulationProfile.set(null);
  }
}
